import { UserSettingsPages } from "@components/settings/constants";
import { useSettings } from "@components/settings/SettingsProvider";
import { SideNavItem } from "@design-system/SideNav/SideNavItem";
import { SideNavSection } from "@design-system/SideNav/SideNavSection";
import { RobotIcon, RulesIcon } from "@icons";
import { useNavigationShortcutKeys } from "./useNavigationShortcutKeys";
import type { SideNavSectionState } from "./sideNavSection.types";

/** Rules, then Connectors, which opens Settings > Connectors; Skills is not shipped yet. */
export const AutomationSection = ({
    section,
}: {
    section: SideNavSectionState;
}) => {
    const { open: openSettings } = useSettings();
    const shortcutKeys = useNavigationShortcutKeys();

    return (
        <SideNavSection {...section}>
            <SideNavItem
                to="/rules"
                icon={<RulesIcon />}
                label="Rules"
                shortcut={shortcutKeys("/rules")}
            />
            <SideNavItem
                onClick={() => openSettings([UserSettingsPages.MCP_CLI])}
                icon={<RobotIcon />}
                label="Connectors"
            />
        </SideNavSection>
    );
};
